import { render, staticRenderFns } from "./ModalUploading.vue?vue&type=template&id=bc3f14fa&scoped=true&"
import script from "./ModalUploading.vue?vue&type=script&lang=js&"
export * from "./ModalUploading.vue?vue&type=script&lang=js&"
import style0 from "./ModalUploading.vue?vue&type=style&index=0&id=bc3f14fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3f14fa",
  null
  
)

export default component.exports